import styled from 'styled-components';

export const Label = styled.label`
  color: var(--FORM-LABEL-default);
  font-family: 'inter-regular', sans-serif;
  font-weight: 500;
`;
